module.exports = __webpack_public_path__ + "static/media/YM52_1.aafd8356.jpg";